import { render, staticRenderFns } from "./TextFieldPhoneNumber.vue?vue&type=template&id=2bd4da1e&"
import script from "./TextFieldPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./TextFieldPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldPhoneNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports